import SMRestClient from 'lib/SMRestClient';
import SMStorage from 'lib/SMStorage';
import sprintf from 'sprintf';

class SMMasterResource {
  static getLargeAreas(countryId, completion){
    
    const cacheKey = sprintf("large_areas-%s", countryId);
    const cache = SMStorage.getPersistentItem(cacheKey);
    if (cache) {
      completion(cache);
      return;
    }
    const apiClient = new SMRestClient();
    apiClient.get(sprintf("/1/large_areas.json?country_id=%d", countryId)).
      done(function(data, textStatus, xhr) {
        SMStorage.setPersistentItem(cacheKey, data, 60 * 60 * 24);
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getTimeZones(completion){
    const cacheKey = "time_zones";
    const cache = SMStorage.getPersistentItem(cacheKey);
    if (cache) {
      completion(cache);
      return;
    }
    const apiClient = new SMRestClient();
    apiClient.get("/1/time_zones.json").
      done(function(data, textStatus, xhr) {
        SMStorage.setPersistentItem(cacheKey, data, 60 * 60 * 24);
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
  
  static getEventTypes(completion){
    const cacheKey = "eventTypes";
    const cache = SMStorage.getPersistentItem(cacheKey);
    if (cache) {
      completion(cache);
      return;
    }
    const apiClient = new SMRestClient();
    apiClient.get("/1/event_types.json").
      done(function(data, textStatus, xhr) {
        SMStorage.setPersistentItem(cacheKey, data, 60 * 60 * 24);
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
  
  static getSpaceTypes(completion){
    const cacheKey = "spaceTypes";
    const cache = SMStorage.getPersistentItem(cacheKey);
    if (cache) {
      completion(cache);
      return;
    }
    const apiClient = new SMRestClient();
    apiClient.get("/1/space_types.json").
      done(function(data, textStatus, xhr) {
        SMStorage.setPersistentItem(cacheKey, data, 60 * 60 * 24);
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getAmenities(completion){
    const cacheKey = "amenities";
    const cache = SMStorage.getPersistentItem(cacheKey);
    if (cache) {
      completion(cache);
      return;
    }
    const apiClient = new SMRestClient();
    apiClient.get("/1/amenities.json").
      done(function(data, textStatus, xhr) {
        SMStorage.setPersistentItem(cacheKey, data, 60 * 60 * 24);
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
  
  static getCapacities(completion){
    const cacheKey = "capacities";
    const cache = SMStorage.getPersistentItem(cacheKey);
    if (cache) {
      completion(cache);
      return;
    }
    const apiClient = new SMRestClient();
    apiClient.get("/1/capacities.json").
      done(function(data, textStatus, xhr) {
        SMStorage.setPersistentItem(cacheKey, data, 60 * 60 * 24);
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getJobs(completion){
    const cacheKey = "jobs";
    const cache = SMStorage.getPersistentItem(cacheKey);
    if (cache) {
      completion(cache);
      return;
    }
    const apiClient = new SMRestClient();
    apiClient.get("/1/jobs.json").
      done(function(data, textStatus, xhr) {
        SMStorage.setPersistentItem(cacheKey, data, 60 * 60 * 24);
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static getIndustries(completion){
    const cacheKey = "industries";
    const cache = SMStorage.getPersistentItem(cacheKey);
    if (cache) {
      completion(cache);
      return;
    }
    const apiClient = new SMRestClient();
    apiClient.get("/1/industries.json").
      done(function(data, textStatus, xhr) {
        SMStorage.setPersistentItem(cacheKey, data, 60 * 60 * 24);
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
  
  static getRoomFeatures(completion){
    const cacheKey = "roomFeatures";
    const cache = SMStorage.getPersistentItem(cacheKey);
    if (cache) {
      completion(cache);
      return;
    }
    const apiClient = new SMRestClient();
    apiClient.get("/1/room_features.json").
      done(function(data, textStatus, xhr) {
        SMStorage.setPersistentItem(cacheKey, data, 60 * 60 * 24);
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
}
export default SMMasterResource;


// WEBPACK FOOTER //
// ./app/javascript/resources/SMMasterResource.js